import type { ActiveTabId } from 'utils/chat-sidebar-layout-storage';

/** מוסיף/מעדכן פרמטר `view` ב-query — לסנכרון טאבים עם ה-URL */
export function appendViewQueryToPath(path: string, viewId: ActiveTabId): string {
  const qIdx = path.indexOf('?');
  const pathname = qIdx >= 0 ? path.slice(0, qIdx) : path;
  const search = qIdx >= 0 ? path.slice(qIdx + 1) : '';
  const sp = new URLSearchParams(search);
  sp.set('view', viewId);
  const qs = sp.toString();
  return qs ? `${pathname}?${qs}` : pathname;
}
